import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { hasFullDashboardAccess } from '@/features/auth/roleAccess';

const SCHOOL_PROFILE_PATH = '/reports/school-profile';

interface RequireFullAccessProps {
  children: ReactNode;
}

/**
 * Limits route to Admin / SuperAdmin. Other authenticated roles are redirected to School Profile.
 */
export function RequireFullAccess({ children }: RequireFullAccessProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-indigo-600 border-t-transparent" />
      </div>
    );
  }

  if (!hasFullDashboardAccess(user?.roles)) {
    return <Navigate to={SCHOOL_PROFILE_PATH} replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
